// cordova-plugin-chrome-apps-sockets-udp
//
// API reference: https://developer.chrome.com/docs/extensions/reference/sockets_udp/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Log } from '../../../../log';
const log = Log.channel('ChromeAppsSocketsUdp');
let idExtra = 0;
let prevDate = 0;
let systemListenerId = undefined;
const receiveListeners = {};
export class ChromeAppsSocketsUdpError extends Error {
    constructor(errorInfo) {
        super(errorInfo.message);
        this.code = errorInfo.resultCode;
    }
}
export function addReceiveListener(socketId, receiveCallback, errorCallback) {
    if (systemListenerId === undefined) {
        const systemListener = {
            socketId: -1,
            receiveCallback: (info) => {
                const hasListener = Object.values(receiveListeners).some(rl => rl.socketId === info.socketId);
                if (!hasListener) {
                    log.warning(`received data for socketId = ${info.socketId} with no listener: ${JSON.stringify(info, null, 4)}`);
                }
            },
            errorCallback: (error) => {
                const hasListener = Object.values(receiveListeners).some(rl => rl.socketId === error.socketId);
                if (!hasListener) {
                    log.error(`receive error for socketId = ${error.socketId} with no listener; error = ${JSON.stringify(error)}`);
                }
            },
        };
        systemListenerId = getListenerId();
        receiveListeners[systemListenerId] = systemListener;
        chrome.sockets.udp.onReceive.addListener(systemListener.receiveCallback);
        chrome.sockets.udp.onReceiveError.addListener(systemListener.errorCallback);
    }
    const listener = {
        socketId,
        receiveCallback: (info) => {
            if (info.socketId === socketId)
                receiveCallback(info);
        },
        errorCallback: (error) => {
            if (error.socketId === socketId)
                errorCallback(error);
        },
    };
    const id = getListenerId();
    receiveListeners[id] = listener;
    chrome.sockets.udp.onReceive.addListener(listener.receiveCallback);
    chrome.sockets.udp.onReceiveError.addListener(listener.errorCallback);
    const numListeners = Object.keys(receiveListeners).length;
    if (numListeners > 100) {
        log.warning(`${numListeners} receive listeners seems like a lot`);
    }
    return id;
}
export function bind(socketId, address, port) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.bind(socketId, address, port, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function close(socketId) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.close(socketId, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function create(props) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.create(props, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function getInfo(socketId) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.getInfo(socketId, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
function getListenerId() {
    const date = Date.now().valueOf();
    if (prevDate !== date)
        idExtra = 0;
    return `${date}.${idExtra++}`;
}
export function joinGroup(socketId, address) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.joinGroup(socketId, address, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function leaveGroup(socketId, address) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.leaveGroup(socketId, address, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function removeReceiveListener(listenerId) {
    const listener = receiveListeners[listenerId];
    if (listener === undefined) {
        log.error(`removeReceiveListener: invalid listenerId`);
        return;
    }
    chrome.sockets.udp.onReceive.removeListener(listener.receiveCallback);
    chrome.sockets.udp.onReceiveError.removeListener(listener.errorCallback);
    delete receiveListeners[listenerId];
}
export function send(socketId, data, address, port) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.send(socketId, data, address, port, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function setBroadcast(socketId, enabled) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.setBroadcast(socketId, enabled, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function setMulticastLoopbackMode(socketId, enabled) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.setMulticastLoopbackMode(socketId, enabled, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
export function setPaused(socketId, paused) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            chrome.sockets.udp.setPaused(socketId, paused, resolve, errorInfo => reject(new ChromeAppsSocketsUdpError(errorInfo)));
        });
    });
}
